import styled from 'styled-components'

import { Box, Text } from '@usap/uicomponents'

export const Container = styled(Box)`
  width:  calc(${props => props.width} - 8px);
  margin: 4px 4px 20px;
  &:hover {
    box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.11);
  }

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    margin: 8px;
    width: calc(16.66% - 16px)
  }
`
export const ImageText = styled(Text)`
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  &:hover {
    color: #2e4787;
  }
`

export const ItemBox = styled(Box)`
  padding: 0px;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    padding: 8px;
  }
`

export const ItemImageBox = styled(Box)`
  align-self: center;
  justify: center;
  padding: 0 8px;
  margin-bottom: 8px;
  height: 90px;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    height: 160px;
    padding: 16px;
  }
`

export const ItemImageTextContainer = styled(Box)`
  padding: 8px;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    padding: 8px auto;
  }
`

export const NewBadge = styled(Text)`
  color: #0E3080;
  font-weight: 700;
  height: 0;
  top: 10px;
  position: relative;
  font-size: 12px;
  height: 16px;
  max-width: 288px;
  left: 5%;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    left: 7%;
  }
`
